module.exports = __webpack_public_path__ + "img/loginOuta.4f244fb0.svg";